<template>
  <div>
    <div>
      <form
        class="row header"
        name="header_form"
        autocomplete="no"
        @submit.prevent="searchObject"
      >
        <div class="col-md-9">
          <h2>Objekt-Suche</h2>
          <div class="container_fluid">
            <div class="row">
              <div class="col-sm-6">
                <label>Straße</label>
                <input
                  v-model="fData.street"
                  class="form-control"
                  :disabled="validated"
                />
              </div>
              <div class="col-sm-2">
                <label>Haus-Nr.</label>
                <input
                  v-model="fData.hsnr"
                  class="form-control"
                  :disabled="validated"
                />
              </div>
              <div class="col-sm-4">
                <label>Objekt-Nummer</label>
                <input
                  v-model="fData.property_nr"
                  class="form-control"
                  :disabled="validated"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <label>Postleitzahl</label>
                <input
                  v-model="fData.zip"
                  class="form-control"
                  :disabled="validated"
                >
              </div>
              <div class="col-sm-4">
                <label>Ort</label>
                <input
                  v-model="fData.city"
                  class="form-control"
                  :disabled="validated"
                />
              </div>
              <div class="col-sm-3">
                <label>Bundesland</label>
                <select
                  v-model="fData.county"
                  class="form-control"
                  :disabled="validated"
                >
                  <option value="">
                    --- Suche ---
                  </option>
                  <option value="BW">
                    Baden-Württemberg
                  </option>
                  <option value="BY">
                    Bayern
                  </option>
                  <option value="BE">
                    Berlin
                  </option>
                  <option value="BB">
                    Brandenburg
                  </option>
                  <option value="HB">
                    Bremen
                  </option>
                  <option value="HH">
                    Hamburg
                  </option>
                  <option value="HE">
                    Hessen
                  </option>
                  <option value="MV">
                    Mecklenburg-Vorpommern
                  </option>
                  <option value="NI">
                    Niedersachsen
                  </option>
                  <option value="NW">
                    Nordrhein-Westfalen
                  </option>
                  <option value="RP">
                    Rheinland-Pfalz
                  </option>
                  <option value="SL">
                    Saarland
                  </option>
                  <option value="SN">
                    Sachsen
                  </option>
                  <option value="ST">
                    Sachsen-Anhalt
                  </option>
                  <option value="SH">
                    Schleswig-Holstein
                  </option>
                  <option value="TH">
                    Thüringen
                  </option>
                </select>
              </div>
              <div class="col-sm-3">
                <button
                  type="submit"
                  class="btn btn-danger search-btn"
                >
                  Suche starten
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <h2 style="overflow: hidden;">
            Mitarbeiter
          </h2>
          <strong>{{ company.name }}</strong><br>
          {{ employee.forename }} {{ employee.surname }}<br>
          <br>
          {{ company.street }} {{ company.hsnr }}<br>
          {{ company.zip }} {{ company.city }}<br>
        </div>
      </form>
    </div>
    <ObjectList
      :prop-list="filteredList"
      :found-object="filterSuccess"
    ></ObjectList>
  </div>
</template>
<script>
import ObjectList from './ObjectList.vue'
export default {
  components: {
    ObjectList
  },
  data () {
    return {
      validated: false,
      properties: [],
      filterSuccess: false,
      company: {},
      employee: {},
      fData: {
        street: '',
        hsnr: '',
        zip: '',
        city: '',
        county: '',
        property_nr: ''
      },
      searchData: {
        street: [],
        hsnr: [],
        zip: [],
        city: [],
        county: [],
        property_nr: []
      },
      filteredList: []
    }
  },
  mounted () {
    var selfId = localStorage.getItem('id')
    this.$axios.get(process.env.VUE_APP_BASE_URI + 'showEmployee/' + selfId)
      .then((response) => {
        this.company = response.data
        this.employee = response.data.employee
      })
    this.$axios.get(process.env.VUE_APP_BASE_URI + 'sadmin/props')
      .then((response) => {
        this.properties = response.data
        this.searchObject()
      })
  },
  methods: {
    searchObject () {
      this.filterSuccess = false
      this.clearSearchData()
      for (var key in this.fData) {
        if (this.fData[key] !== '') {
          this.properties.forEach(prop => {
            if (prop[key] !== null) {
              if (prop[key].toLowerCase().includes(this.fData[key].toLowerCase())) {
                this.searchData[key].push(prop)
              }
            }
          })
        }
      }
      this.intersectSearchData()
    },
    clearSearchData () {
      for (var key in this.searchData) {
        this.searchData[key] = []
      }
    },
    intersectSearchData () {
      var result = []
      var id_list = []
      var key_id_list = []
      for (var key in this.searchData) {
        if (this.searchData[key].length > 0) {
          key_id_list = []
          this.searchData[key].forEach(keyData => {
            key_id_list.push(keyData.id)
          })
          id_list.push(key_id_list)
        }
      }
      if (id_list.length === 1) {
        result = id_list[0]
      } else {
        result = this.intersection(id_list)
      }
      this.buildSearchList(result)
    },
    intersection (id_list) {
      var result = {}
      for (var arr in id_list) {
        for (var i = 0; i < id_list[arr].length; i++) {
          var values = id_list[arr][i]
          if (result[values] === undefined) {
						result[values] = 1
          } else result[values] += 1
        }
      }
      let answer = []
      for (var key in result) {
        if (result[key] >= id_list.length) answer.push(Number(key))
      }
      return answer
    },
    buildSearchList (result) {
      this.filteredList = []
      if (result.length === 0) {
        this.filteredList = this.properties
      } else {
        this.properties.forEach(prop => {
          this.filterSuccess = true
          if (result.includes(prop.id)) {
            this.filteredList.push(prop)
          }
        })
      }
    }
  }
}
</script>
<style>
</style>
